// extracted by mini-css-extract-plugin
module.exports = {"root":"SectionHeader_root__2kXRe","heading":"SectionHeader_heading__UPEP-","for-form":"SectionHeader_for-form__2aqji","for-table":"SectionHeader_for-table__3uH99"};